import Backbone from "backbone";
import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';
import { getTypeBanner } from '@/js/common/Domain/Service/getTypeBanner';
import { mountCheckboxes, validateRequiredCheckboxes } from '@/js/common/Service/checkboxValidation';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import CheckBoxInputCommon from '@ve/components/inputs/common/CheckBoxInputCommon.vue';
import template from './template.html';
import requestService from '../../Domain/Service/request';

const LifeHackBannerView = Backbone.Epoxy.View.extend({
    template,
    bindings: {
        '.js-step-1': 'toggle:not(lifeHackBannerEmailWasSend)',
        '.js-step-2': 'toggle:lifeHackBannerEmailWasSend',
        button: 'classes:{loading:loading}',
    },
    initialize() {
        this.viewModel = new (Backbone.Model.extend({
            defaults: {
                loading: false,
                lifeHackBannerEmailWasSend: false,
            },
        }))();
        this.checkboxState = new Backbone.Model({
            agreeAdvertising: false,
        });
        this.$el.html(this.template);
        this.dataLayerAnalytics = new DataLayerAnalytics();
        this.initDOMEvents();
        this.checkboxId = 'lifehack-advertising-checkbox-' + Date.now();
        this.mountAdvertisingCheckboxWhenReady();
    },
    initDOMEvents() {
        setTimeout(() => {
            const $form = this.$el.find('form');
            $form.validate({
                errorElement: 'div',
                rules: {
                    email: {
                        required: true,
                        email: true,
                    },
                },
                messages: {
                    email: {
                        required: 'Обязательное поле',
                        email: 'Введите правильный email',
                    },
                },
            });

            $form.on('click', 'button', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if ($form.valid() && !this.viewModel.get('loading')) {
                    if (!validateRequiredCheckboxes(this.checkboxState, ['agreeAdvertising'], this.$el[0])) {
                        return;
                    }
                    this.formSubmit($form.find('input').val());
                }
            });
        }, 10);
    },
    async formSubmit(email) {
        this.viewModel.set('loading', true);
        const mindBoxUuid = await mindBoxService.getUuidMindbox();
        const context = getTypeBanner('8tips');
        requestService({
            type: 'POST',
            url: window.appConfig.apiGatewayUrl + '/frontend/subscriptions',
            contentType: 'application/json',
            data: JSON.stringify({
                email,
                pointOfContact: context,
                deviceUUID: mindBoxUuid,
            }),
        }).done((data) => {
            this.viewModel.set('loading', false);
            if (data && data.success) {
                this.viewModel.set('lifeHackBannerEmailWasSend', true);
                this.dataLayerAnalytics.subscribeEmail();
            }
        }).fail(() => {
            this.viewModel.set('loading', false);
        });
    },
    mountAdvertisingCheckboxWhenReady(container = this.$el[0]) {
        const tryMount = () => {
            const $checkbox = container.querySelector('#lifehack-advertising-checkbox');
            if ($checkbox) {
                $checkbox.setAttribute('id', this.checkboxId);
                mountCheckboxes([
                    {
                        id: this.checkboxId,
                        modelKey: 'agreeAdvertising',
                        labelVNode: (h) => h('span', [
                            'Я даю ',
                            h('a', {
                                attrs: {
                                    href: '/consent-to-advertising',
                                    target: '_blank',
                                    class: 'link',
                                },
                            }, 'согласие на получение рекламных сообщений'),
                        ]),
                        disabled: false,
                        labelClass: 'subscribe-block-checkbox-label subscribe-block-checkbox-label_orange',
                        themeIcon: true,
                    },
                ], this.checkboxState, CheckBoxInputCommon, container);
                return true;
            }
            return false;
        };
        if (!tryMount()) {
            const observer = new MutationObserver(() => {
                if (tryMount()) observer.disconnect();
            });
            observer.observe(container, { childList: true, subtree: true });
        }
    }
});

export default LifeHackBannerView;
